'use client';

import { FaDesktop } from 'react-icons/fa';
import { IoIosMoon } from 'react-icons/io';
import { IoSunny } from 'react-icons/io5';

import { useTheme } from '@web/theme';

import { SecondaryButton } from '../atomic-atoms';

export function ThemeToggle() {
  const { theme, setTheme } = useTheme();

  return (
    <div
      className="card-container-glass-small"
      style={{ display: 'flex', gap: 4 }}
    >
      <SecondaryButton
        variant="mini"
        ariaLabel="Light theme"
        backgroundOverride={theme === 'light' ? 'emphasis' : 'theme'}
        onClick={() => setTheme('light')}
      >
        <IoSunny />
      </SecondaryButton>

      <SecondaryButton
        variant="mini"
        ariaLabel="System theme"
        backgroundOverride={theme === 'system' ? 'emphasis' : 'theme'}
        onClick={() => setTheme('system')}
      >
        <FaDesktop />
      </SecondaryButton>

      <SecondaryButton
        variant="mini"
        ariaLabel="Dark theme"
        backgroundOverride={theme === 'dark' ? 'emphasis' : 'theme'}
        onClick={() => setTheme('dark')}
      >
        <IoIosMoon />
      </SecondaryButton>
    </div>
  );
}
